module.exports = __webpack_public_path__ + "static/img/icon_kf.f8490efd.svg";